import { AppFooter } from "./app-footer";
import { Outlet } from "react-router";

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
      <AppFooter />
    </div>
  );
}
